import type { AnaliticsValue } from './interface';

export const formatValue = (value: AnaliticsValue) => {
  if (!value) {
    return undefined;
  }

  if (Array.isArray(value)) {
    return value.join('|');
  }

  return value.toString();
};
